import React from "react";
import {Field} from "formik";
import {InputTextarea} from "primereact/inputtextarea";

export default function NsFieldTextarea({
                                            name,
                                            value = '',
                                            formikRef,
                                            onChange = () => {
                                            },
                                            rows = 3,
                                            cols = 50,
                                            readOnly = false,
                                            isDisabled = false,
                                            validate = () => {
                                            },
                                            isFormFieldInvalid,
                                        }) {

    return (
        formikRef && typeof formikRef !== "undefined" ?
            <Field
                name={name}
                component={InputTextarea}
                className="w-100"
                rows={rows} cols={cols}
                readOnly={readOnly}
                value={value}
                disabled={isDisabled}
                onChange={(e) => {
                    if (formikRef) {
                        formikRef.current.setFieldValue(name, e.target.value);
                    }
                    onChange(e);
                }}
                validate={validate}
                invalid={isFormFieldInvalid()}
            />
            :
            <InputTextarea
                name={name}
                className="w-100"
                rows={rows} cols={cols}
                readOnly={readOnly}
                value={value}
                disabled={isDisabled}
                onChange={(e) => {
                    onChange(e);
                }}
                invalid={isFormFieldInvalid()}
            />
    );
}